export default "__VITE_ASSET__eb360262__"